<script setup lang="ts">
import { RouterView } from 'vue-router'
import { watch, ref, onBeforeUnmount, onMounted } from 'vue'
import { useHtmlLang } from '@/composables/useSeo'
import { useAuthSync } from '@/composables/useAuthSync'
import { useAuthStore } from '@/stores/auth'
import { startPushClient, stopPushClient } from '@/utils/pushClient'
import SiteHeader from '@/components/SiteHeader.vue'
import SiteFooter from '@/components/SiteFooter.vue'
import YfbToast from '@/components/YfbToast.vue'

// 自研 Toast 浮层仅客户端挂载（vite-ssg 预渲染阶段不产出浮层节点）
const toastMounted = ref(false)
onMounted(() => {
  toastMounted.value = true
})

// 启用 <html lang> 跟 i18n locale 联动
useHtmlLang()

// 登录态同步：页面加载校验一次 + 跨标签 storage 事件联动（账号级登录态）
useAuthSync()

// 实时推送：登录后启动 WS 订阅个人频道、登出断开（仅 client 端；收银台仍由轮询兜底）
if (typeof window !== 'undefined') {
  const auth = useAuthStore()
  watch(
    () => auth.isLoggedIn,
    (loggedIn) => {
      if (loggedIn) startPushClient()
      else stopPushClient()
    },
    { immediate: true }
  )
  onBeforeUnmount(() => stopPushClient())
}
</script>

<template>
  <div class="app">
    <SiteHeader />
    <main id="main-content" class="app__main">
      <RouterView />
    </main>
    <SiteFooter />

    <!-- 全局瞬态提示（自研 YfbToast，client-only；规范见 ui-skills.md 三-bis） -->
    <YfbToast v-if="toastMounted" />
  </div>
</template>

<style scoped>
.app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: var(--yfb-surface);
  color: var(--yfb-ink);
}

.app__main {
  flex: 1;
  width: 100%;
  outline: none;
}
</style>